import { FuseUtils } from '@fuse/utils';

export class UserFLT {
  Id: string;
  Email: string;
  Password: string;

  /**
   * Constructor
   *
   * @param contact
   */
  constructor() {
   
  }
}
